import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';

const calendarDataStoreDefaults = {
    monthText: {
        size: '24px',
        color: '#4a4767',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'center',
        font: 'IBM Plex sans'
    },
    dayOfWeekText: {
        size: '13px',
        color: '#000000',
        style: 'normal',
        weight: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'center',
        font: 'IBM Plex sans'
    },
    dateBackgroundColor: {
        selected: '#C39170',
        available: '#FFFFFF',
        unavailable: '#D9D9D9'
    },
    dateColor: {
        selected: '#FFFFFF',
        available: '#000000',
        unavailable: '#000000'
    },
    dateText: {
        size: '22px',
        style: 'normal',
        weight: 'bold',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'center',
        font: 'IBM Plex sans'
    },
    border: {
        color: '#CACACA',
        noDateColor: '#E7E7E7',
        style: 'solid',
        width: '1px'
    },
    general: {
        popupBackgroundColor: '#000000',
        popupColor: '#FFFFFF'
    },
    popupPriceText: {
        size: '16px',
        style: 'normal',
        weight: 'bold',
        align: 'center',
        font: 'IBM Plex Sans'
    },
    popupPriceTypeText: {
        size: '16px',
        style: 'normal',
        weight: 'bold',
        align: 'center',
        font: 'IBM Plex Sans'
    }
};

const calendarDataReducer = handleActions(
    {
        [ActionTypes.SET_CALENDAR_THEME_VALUE]: (state, action) => {
            const { path, value } = action;
            const calendar = {
                calendar: {
                    ...state.calendar
                }
            };
            _.set(calendar, path, value);
            return { ...state, ...calendar };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_FONT]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            if (action.layer === 'defaultLink') {
                obj['calendar']['link'] = { ...state['calendar']['link'], font: action.font };
            } else {
                obj['calendar'][action.layer] = { ...state['calendar'][action.layer], font: action.font };
            }
            obj[action.layer] = { ...state[action.layer], font: action.font };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_FONT_COLOR]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['border'] = { ...state['calendar']['border'] };
            obj['calendar']['border'] = { ...state['calendar']['border'], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_FONT_SIZE]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['border'] = { ...state['calendar']['border'] };
            obj['calendar']['border'] = { ...state['calendar']['border'], width: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_FONT_WEIGHT]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            if (action.layer === 'defaultLink') {
                obj['calendar']['link'] = { ...state['calendar']['link'], weight: action.weight };
            } else {
                obj['calendar'][action.layer] = { ...state['calendar'][action.layer], weight: action.weight };
            }
            obj[action.layer] = { ...state[action.layer], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_FONT_STYLE]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['border'] = { ...state['calendar']['border'] };
            obj['calendar']['border'] = { ...state['calendar']['border'], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_TEXT_DECORATION]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'] };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'], textSize: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_SPINNER_COLOR1]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'] };
            obj['calendar']['popupPrice']['spinner'] = {
                ...state['calendar']['popupPrice']['spinner'],
                color1: action.color1
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_SPINNER_COLOR2]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'] };
            obj['calendar']['popupPrice']['spinner'] = {
                ...state['calendar']['popupPrice']['spinner'],
                color2: action.color2
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_TEXT_ALIGN]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            if (action.layer === 'defaultLink') {
                obj['calendar']['link'] = { ...state['calendar']['link'], align: action.align };
            } else {
                obj['calendar'][action.layer] = { ...state['calendar'][action.layer], align: action.align };
            }
            obj[action.layer] = { ...state[action.layer], align: action.align };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_LINE_HEIGHT]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            if (action.layer === 'defaultLink') {
                obj['calendar']['link'] = { ...state['calendar']['link'], lineHeight: action.lineHeight };
            } else {
                obj['calendar'][action.layer] = { ...state['calendar'][action.layer], lineHeight: action.lineHeight };
            }
            obj[action.layer] = { ...state[action.layer], lineHeight: action.lineHeight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_POPUP_COLOR]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'] };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'], textColor: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_THEME_POPUP_BACKGROUND]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'] };
            obj['calendar']['popupPrice'] = { ...state['calendar']['popupPrice'], background: action.background };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_DATE_SELECTED]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['date'] = { ...state['calendar']['date'], selected: action.selected };
            obj['calendar']['date']['selected'] = {
                ...state['calendar']['date']['selected'],
                [action.layer]: action.selected
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_DATE_AVAILABLE]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['date'] = { ...state['calendar']['date'], available: action.available };
            obj['calendar']['date']['available'] = {
                ...state['calendar']['date']['available'],
                [action.layer]: action.available
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_DATE_UNAVAILABLE]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['date'] = { ...state['calendar']['date'], unavailable: action.unavailable };
            obj['calendar']['date']['unavailable'] = {
                ...state['calendar']['date']['unavailable'],
                [action.layer]: action.unavailable
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_DATE_HOVER]: (state, action) => {
            let obj = {
                calendar: {
                    ...state.calendar
                }
            };
            obj['calendar']['date'] = { ...state['calendar']['date'], hover: action.hover };
            obj['calendar']['date']['hover'] = { ...state['calendar']['date']['hover'], [action.layer]: action.hover };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_BORDER_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_BORDER_NO_DATE_COLOR]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], noDateColor: action.noDateColor };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_BORDER_STYLE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CALENDAR_SET_BORDER_WIDTH]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer], width: action.width };
            return { ...state, ...obj };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('calendar')) {
                return { ...state, calendar: action.theme.calendar };
            } else {
                return state;
            }
        }
    },
    calendarDataStoreDefaults
);

export default calendarDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/calendar.js